export function MicFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path fill="currentColor" d="M12 2a4 4 0 00-4 4v4a4 4 0 008 0V6a4 4 0 00-4-4z"></path>
      <path
        fill="currentColor"
        d="M6 9a1 1 0 00-2 0v1a8.001 8.001 0 007.002 7.938A.97.97 0 0011 18v2h-1a1 1 0 100 2h4a1 1 0 100-2h-1v-2c0-.02 0-.041-.002-.062A8.001 8.001 0 0020 10V9a1 1 0 10-2 0v1a6 6 0 01-12 0V9z"
      ></path>
    </svg>
  );
}
